module.exports = __webpack_public_path__ + "img/digital-login.8b1e2c85.png";